export default "__VITE_ASSET__iSO4l_mn__"